module.exports = __webpack_public_path__ + "img/capacitor-yellow.6fc44b05.png";